export enum LocalStorageKeysEnum {
  authState = 'authState',
  cookiesAllowed = 'cookiesAllowed',
}
